/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PaginationInputs */

const en_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagination`)
};

const ar_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترقيم`)
};

const bn_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পেজিনেশন`)
};

const de_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paginierung`)
};

const es_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paginación`)
};

const fr_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagination`)
};

const pt_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paginação`)
};

const zh_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分页`)
};

const tr_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfalandırma`)
};

const ru_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пагинация`)
};

const pl_svchip_pagination = /** @type {(inputs: Svchip_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paginacja`)
};

/**
* | output |
* | --- |
* | "Pagination" |
*
* @param {Svchip_PaginationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_pagination = /** @type {((inputs?: Svchip_PaginationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PaginationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_pagination(inputs)
	if (locale === "bn") return bn_svchip_pagination(inputs)
	if (locale === "de") return de_svchip_pagination(inputs)
	if (locale === "es") return es_svchip_pagination(inputs)
	if (locale === "fr") return fr_svchip_pagination(inputs)
	if (locale === "pt") return pt_svchip_pagination(inputs)
	if (locale === "zh") return zh_svchip_pagination(inputs)
	if (locale === "tr") return tr_svchip_pagination(inputs)
	if (locale === "ru") return ru_svchip_pagination(inputs)
	if (locale === "pl") return pl_svchip_pagination(inputs)
	return en_svchip_pagination(inputs)
});